<div fxLayout="column" fxFlex="grow" style="margin-top:50px;">

  <div fxLayout="row">

    <div fxFlex="grow" class="pageTitle" style="font-size: 22px;" fxLayoutAlign="start center center">{{pageTitle}}</div>

    <div fxLayoutGap="5px" fxLayoutAlign="end center center" *ngIf="buttonAction ==='newForm'">
      <button mat-raised-button
              style="color:white; background-color: #00bfa5; font-family: 'Century Gothic', sans-serif"
              matTooltip="Δημιουργία νέας δήλωσης" (click)="navigateToFormCreator()">
        Δημιουργία νέας δήλωσης
      </button>
    </div>




    <div fxLayoutAlign="end center center" *ngIf="subAction" style="margin-left: 5px;">
      <button mat-raised-button
              style="color:white; background-color: #00bfa5; font-family: 'Century Gothic', sans-serif"
              matTooltip="Δημιουργία νέας δήλωσης" (click)="navigateToCustomFormCreator()">
        Δημιουργία νέας δήλωσης
      </button>
    </div>

    <div fxLayoutAlign="end center center" *ngIf="subAction" style="margin-left: 5px;">
      <button mat-raised-button
              style="color:white; background-color: #7c3aed; font-family: 'Century Gothic', sans-serif"
              matTooltip="Δημιουργία δήλωσης με AI" (click)="navigateToAiFormCreator()">
        <mat-icon style="margin-right: 5px; font-size: 18px; vertical-align: middle;">auto_awesome</mat-icon>
        AI Δημιουργός
      </button>
    </div>

    <div fxLayoutAlign="end center center" *ngIf="buttonAction ==='newAnnouncement'">
      <button mat-raised-button
              style="color:white; background-color: #00bfa5; font-family: 'Century Gothic', sans-serif"
              matTooltip="Δημιουργία νέας ανακοίνωσης" (click)="navigateToAnnouncementCreator()">
        Δημιουργία νέας ανακοίνωσης
      </button>
    </div>

  </div>
<!--#ed4e5d-->
<!--  <mat-divider ngStyle.lt-md="width:100%;" ngStyle.gt-sm="width:55%;" style="margin-top:5px;"></mat-divider>-->
</div>
